<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{ 'users.rolesList.title.shortLabel' | translate }}
                <app-tooltip [text]="'users.rolesList.title.summary' | translate"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <section class="creation-form" *ngIf="isEditAllowed">
            <button *ngIf="!isCreationMode" (click)="onEdit()"
                [matTooltip]="'users.rolesList.add.summary' | translate"
                mat-mini-fab class="action-button" color="accent">
                <mat-icon aria-label="Add">group_add</mat-icon>
            </button>
            <app-role-edit *ngIf="isCreationMode && !editedCode" (editFinished)="onEditFinished()"></app-role-edit>
        </section>

        <table mat-table [dataSource]="dataSource" multiTemplateDataRows
                matSort matSortActive="role" matSortDirection="asc" matSortDisableClear>
            <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'users.rolesList.role.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let role;"> {{ role.text.shortLabel }} </td>
            </ng-container>

            <ng-container matColumnDef="quotas">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'users.rolesList.quota.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let role;"> {{ role.userQuota.value }}/{{ role.userQuota.max }} </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> {{ 'users.usersList.actions.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let role;">
                    <ng-container *ngIf="role.code !== editedCode">
                        <button mat-icon-button class="action-button" color="accent"
                            [matTooltip]="'users.rolesList.edit.summary' | translate"
                            (click)="onEdit(role.code)"
                            [disabled]="isLoading">
                            <mat-icon aria-label="Edit">edit</mat-icon>
                        </button>
                        <button mat-icon-button class="action-button" color="accent"
                            [matTooltip]="'users.rolesList.delete.summary' | translate"
                            (click)="onDelete(role.code)"
                            [disabled]="isLoading || role.userQuota.value !== 0">
                            <mat-icon aria-label="Delete">delete</mat-icon>
                        </button>
                    </ng-container>
                    <mat-spinner class="actions-loading" *ngIf="isLoading" [diameter]="35" color="accent"></mat-spinner>
                </td>
            </ng-container>

            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let role;" [attr.colspan]="displayedColumns.length">
                    <div *ngIf="role.code === editedCode" class="role-edit" [@detailExpand]="role.code === editedCode ? 'expanded' : 'collapsed'">
                        <app-role-edit [role]="role" (editFinished)="onEditFinished()"></app-role-edit>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <!-- <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr> -->
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                class="role-row"
                [class.role-expanded-row]="row.code === editedCode"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="role-detail-row"></tr>
        </table>
    </mat-card-content>
</mat-card>
